import { Clock } from "@phosphor-icons/react";
import { fmtDMY } from "@/lib/api";

export const LastEntry = ({ date }) => {
  if (!date) return null;
  const label = fmtDMY(String(date));
  return (
    <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-md border border-border bg-muted/40" data-testid="last-entry-badge">
      <Clock size={14} weight="bold" className="text-muted-foreground" />
      <span className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground">Last entry</span>
      <span className="font-mono text-xs font-semibold" data-testid="last-entry-date">{label}</span>
    </div>
  );
};
